import directives from '../module';
import {Utils} from 'underscore-extensions';
import {ProjectPageCtrl} from './ProjectPage';

const shareSocialSvc = {show: false};

const networks: {[index: string]: string} = {
    facebook: `https://www.facebook.com/sharer/sharer.php?s=100&p[url]={{::$ctrl.url}}`,
    twitter: `https://twitter.com/intent/tweet?url={{::$ctrl.url}}`,
    'google+': `https://plus.google.com/share?url={{::$ctrl.url}}`,
    tumblr: `https://www.tumblr.com/share/photo?source={{$ctrl.preview}}&caption={{::$ctrl.info}}&click_thru={{::$ctrl.url}}`,
    email: `mailto:?subject={{$ctrl.ProjectPageCtrl.project.name}}%20by%20{{$ctrl.ProjectPageCtrl.project.author.displayName}}&body={{$ctrl.url}}`
};

directives.component('shareSocialButton', {
    controller: class ShareSocialButton implements ng.IComponentController {
        private readonly ProjectPageCtrl: ProjectPageCtrl;
        public readonly shareSocialSvc = shareSocialSvc;

        onClick() {
            shareSocialSvc.show = !shareSocialSvc.show;
            if (shareSocialSvc.show && this.ProjectPageCtrl.player) {
                this.ProjectPageCtrl.player.then(p => p && p.pause());
            }
        };
    },
    require: {ProjectPageCtrl: '^projectPage'},
    template: `
              <span class="popup-opener animatron-grey-btn dropdown-toggle share control"
                ng-click="$ctrl.onClick()" ng-class="{show:$ctrl.shareSocialSvc.show}">
                  <span class="title">{{::$root.t('share')}}</span>
               </span>`
});

directives.component('shareSocialWindow', {
    controller: class ShareSocialWindow implements ng.IComponentController {
        private readonly ProjectPageCtrl: ProjectPageCtrl;
        public readonly shareSocialSvc = shareSocialSvc;
        public url: string;
        public preview: string;
        public info: string;

        constructor(private $scope: ng.IScope,
                    private $timeout: ng.ITimeoutService,
                    private $location: ng.ILocationService,
                    private $element: ng.IAugmentedJQuery) {
        }

        $onInit = () => this.ProjectPageCtrl.projectPromise.then(prj => {
            if (this.ProjectPageCtrl.twoPlayers) return;
            this.url      = encodeURIComponent(this.$location.absUrl());
            this.preview  = encodeURIComponent(prj.preview_metadata[0]);
            this.info     = encodeURIComponent(prj.name + '\n' + prj.description + '\nby ' + prj.author.displayName);
            const destroy = this.$scope.$watch(() => this.ProjectPageCtrl.player, (player: ng.IPromise<Player>) => {
                if (player && player.then) {
                    destroy();
                    player.then(p => {
                        if (!p) return;
                        const showOnPause = _.once(() => {
                            p.on(anm.C.S_PAUSE, () => this.$timeout(() => shareSocialSvc.show = true));
                        });

                        let repeats = 0;
                        if (window.anm) {
                            p.on(anm.C.S_COMPLETE, () => {
                                repeats += 1;
                                if (!p.repeat && !p.repeating && !p.anim.repeat) {
                                    this.$timeout(() => shareSocialSvc.show = true);
                                } else if (repeats >= 1) {
                                    showOnPause();
                                }
                            });
                            p.on(anm.C.S_PLAY, () => this.$timeout(() => shareSocialSvc.show = false));
                        }

                        Utils.scopedEvent('click', this.$scope, (e: MouseEvent) => {
                            const target = <HTMLElement>e.target;
                            if (shareSocialSvc.show && !target.classList.contains('share')) {
                                p.play();
                            }
                            return e;
                        }, this.$element[0]);
                    });

                }
            });
            this.$scope.$on('$destroy', () => shareSocialSvc.show = false);
        });
    },
    require: {ProjectPageCtrl: '^projectPage'},
    template() {
        const items = _.map(networks, (href: string, network: string) =>
            `<a target="_blank" ng-href="${href}" class="popup-opener">
                        <div class="share share-${network}"><i class="icon-${network}"></i></div>
                    </a>`
        ).join('');
        return `
                <div class="animatron-share-menu" ng-class="{show:$ctrl.shareSocialSvc.show}">
                    <div class="share-title">{{::$root.t('project.share')}}</div>
                    <div class="items">${items}</div>
                </div>`;
    }
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/ShareSocial.ts